import StartReadingExperience from '../components/StartReadingExperience';

export default function Landing() {
  return <StartReadingExperience initialVersion="healing" />;
}
